<div class="row  mb-2" *ngIf="global.OnboardType !='CLIENT' &&( csform?.ClientId  == null || csform?.ClientId == undefined
                    || csform?.ClientId== '')">
    <div class="col pl-3">
        <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Consultation Session</h4>
    </div>
</div>
<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
<div class="row mt-4 ">
    <div class="col ">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <div class="text-center text-danger">
                    <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                        agency to
                        view
                        details</label>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col-12 mt-3 p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent">
                <div class="row mt-2" *ngIf="global.OnboardType !='CLIENT' &&( csform?.ClientId  == null || csform?.ClientId == undefined
                    || csform?.ClientId== '')">
            <div class="ml-auto mr-4">
              <button type="button" class="btn btn-primary btn-sm text-right mb-1" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" data-bs-toggle="modal" data-bs-target="#exportascsvmodel">
                Export as CSV
              </button>
            </div>
          </div>
                <div class="d-flex flex-wrap">
                    <div class="col-3 custom-width-sm">
                        <div class="col-lg-12">
                            <label class="fs-size">StartDate</label>
                        </div>
                        <div class="col-lg-8 mt-1">
                            <my-date-picker class="w-100 custom-font-size" placeholder="mm/dd/yyyy" 
                                [options]="myDatePickerOptions"
                                (inputFieldChanged)="newdates($event,'inputchange','StartDate')"
                                [selDate]="FilterStartDate" (dateChanged)="newdates($event,'datechanged','StartDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-3 custom-width-sm">
                        <div class="col-lg-12">
                            <label class="fs-size">EndDate</label>
                        </div>
                        <div class="col-lg-8 mt-1">
                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy" 
                                [options]="myDatePickerOptions"
                                (inputFieldChanged)="newdates($event,'inputchange','EndDate')" [selDate]="FilterEndDate"
                                (dateChanged)="newdates($event,'datechanged','EndDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-3"  *ngIf="global.OnboardType !='CLIENT' &&( csform?.ClientId  == null || csform?.ClientId == undefined
                    || csform?.ClientId== '')" >
                        <div class="col-lg-12" >
                            <label class="fs-size">Client</label>
                        </div>
                        <div class="col-lg-10 mt-1">
                            <ng-select [(ngModel)]="CSBO.clientId"   *ngIf="global.OnboardType =='CLIENT' ||( csform?.ClientId  == null ||  csform?.ClientId == undefined
                            ||  csform?.ClientId== '')" [searchable]="true" [clearable]="true"
                                [items]="ClientList" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3"*ngIf="global.OnboardType !='CLIENT' &&( csform?.ClientId  == null || csform?.ClientId == undefined
                    || csform?.ClientId== '')"  >
                        <div class="col-lg-12">
                            <label class="fs-size">Employee</label>
                        </div>
                        <div class="col-lg-10 mt-1">
                            <ng-select [(ngModel)]="CSBO.employeeId" [searchable]="true" [clearable]="true"
                              [disabled]="!fp"   [items]="UserDropDownList" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-3 custom-width-sm">
                        <div class="col-lg-12">
                            <label class="fs-size">Export Status </label>
                        </div>
                        <div class="col-lg-10 mt-1">
                            <select [(ngModel)]="CSBO.isExported" class="form-control"
                                id="VisitExportStatus">
                                <option value="all">All</option>
                                <option value="exported">Exported</option>
                                <option value="unexported">Not Exported</option>
                            </select>
                        </div>
                    </div>
                      
            <div class="col-lg-3 text-right mt-4"   *ngIf="!(global.OnboardType !='CLIENT' &&( csform?.ClientId  == null || csform?.ClientId == undefined
                    || csform?.ClientId== ''))">
              <button type="button" class="btn btn-primary btn-sm text-right mb-1" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" data-bs-toggle="modal" data-bs-target="#exportascsvmodel">
                Export as CSV
              </button>
            </div>
          
                </div>

            </div>
            <div class="card-body transparent">
                <div class="row mb-2 d-flex justify-content-center align-items-center">
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <button type="button" class="btn btn-sm" data-bs-toggle="modal" 
                        *ngIf="global.OnboardingLoginType == 'agencyLogin'"
                            data-bs-target="#CreateSessionModal"   [disabled]="global.viewTabs" (click)="AddSession()">  
                            Add Session
                        </button>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-6 d-inline-flex justify-content-center mt-2 pt-1">
                    </div>
                    <div class="col-lg-3 col-md-5 col-sm-6">
                    </div>
                    <div class="col-lg-3 col-md-12 col-sm-6 d-flex justify-content-lg-end">
                        <button class="btn btn-sm me-4" type="button"  [disabled]="global.viewTabs" (click)="getCSListFilter()">Apply</button>
                        <button class="btn btn-sm " type="button"  [disabled]="global.viewTabs" (click)="Refresh()"><i
                                class="fa fa-repeat">&nbsp;</i>Refresh</button>
                    </div>
                </div>
                <div class="row mt-2 pt-1">
                    <div class="col-12">
                         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update CSOTotalColumns constant in client.consultation-services.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'CSessionGrid' maps to localStorage key 'gridCSessionGrid'
                                                                          -->
                        <ejs-grid #gridCS id="CSessionGrid" [dataSource]='GridDataCS | async' [allowResizing]='true'
                          [allowReordering]="true" 
                  [enablePersistence]="true"   [allowSorting]='true' [showColumnChooser]='true' [allowPaging]='true'
                            [allowFiltering]='true' (dataStateChange)='dataStateChange($event)'
                            [pageSettings]='initialPage' [filterSettings]='filterOptions'
                            (actionComplete)="onActionComplete($event)">
                            <e-columns>
                                <!--  -->
                                <e-column field='' headerText="Actions" [showInColumnChooser]='false'
                                    textAlign='center'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table" [disabled]="global.OnboardType =='CLIENT' || data.isExported" (click)="editSession(data)"><i
                                                class="fa fa-edit"></i></button>
                                        <button class=" btn btn-delete-table ms-3"  [disabled]="data.isExported || global.OnboardType =='CLIENT' ||( csform?.ClientId  != null &&   csform?.ClientId != undefined
                                        &&  csform?.ClientId != '')" (click)="getDeleteId(data)">
                                            <i class="fa fa-trash "></i></button>
                                        <button class=" btn btn-edit-table ms-3" [disabled]="global.viewTabs" (click)="DownloadSessionForm(data);editData(data);viewpdf=true;">
                                            <i class="fa fa-download "></i></button>
                                         <button class="btn btn-edit-table ms-3" [disabled]="global.viewTabs"  (click)="viewconsultationsession(data);editData(data) ;">
                                            <i class="fa fa-eye"></i>
                                        </button>
                                    </ng-template>
                                </e-column>
                                <!-- Client Name -->
                                <e-column field="clientName" headerText='Client Name' textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- Consultant Name -->
                                <e-column field="userName" headerText="Employee Name" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- Start Time -->
                                <e-column field="CSD" headerText="Start Time" textAlign='left'  type="datetime"
                                [format]='datetimeformat'
                                     [allowFiltering]='false' [allowSorting]='false'>
                                </e-column>
                                <!-- End Time -->
                                <e-column field='CED' headerText='End Time' textAlign='left'   type="datetime"
                                [format]='datetimeformat'
                               [allowFiltering]='false' [allowSorting]='false'>
                                </e-column>
                                <!-- Service code-->
                                <e-column field="serviceCode" headerText="Service Code" textAlign='left'
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                </ng-template>
                               </e-column>
                               
                                <!-- Session Date -->
                                <e-column field='callStartDate' headerText='Session Date' textAlign='left' type='date'
                                    [format]='dateformat' [allowFiltering]='false' [allowSorting]='false'>
                                </e-column>
                                <!-- Session Type -->
                                <e-column field="typeofSession" headerText="Session Type" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- Contact Type -->
                                <e-column field="typeofContact" headerText="Contact Type" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- totalHours -->
                                <e-column field='duration' headerText='Total hours' textAlign='left' type='number'
                                    [allowFiltering]='false' [allowSorting]='false'>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div class="d-none d-lg-block">
                                            <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>

                        </ejs-grid>
                         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update CSOTotalColumns constant in client.consultation-services.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'CSessionGrid' maps to localStorage key 'gridCSessionGrid'
                                                                          -->
                    </div>
                    <div class="col-lg-12">
                        <div *ngIf="CSDataList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- For Create Session -->
<span id="openSessionModal" data-bs-toggle="modal" data-bs-target="#CreateSessionModal"></span>
<div class="modal fade" id="CreateSessionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header border-0">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span
                        *ngIf="saveBo.id==null|| saveBo.id==undefined|| saveBo.id=='00000000-0000-0000-0000-000000000000'">
                        Create Session</span>
                    <span
                        *ngIf="saveBo.id!=null && saveBo.id!=undefined && saveBo.id!='00000000-0000-0000-0000-000000000000'">
                        Update Session</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="clearEngagement()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-2">
                    <div class="col pl-0">
                        <div widget class="card border-0 box-shadow" style="background-color: aliceblue;">
                            <div class="card-body  widget-body pt-2">
                                <div class="row pl-4">
                                    <div class="col-lg-12">
                                        <!-- 1 -->
                                        <div class="row ">
                                            <div class="col-lg-12 br-line">
                                                <div class="row mt-1">
                                                    <!--Client Name -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75"> Client Name</label>
                                                        <ng-select [disabled]="global?.OnboardType =='CLIENT'  ||( csform?.ClientId  != null &&   csform?.ClientId != undefined
                                                        &&  csform?.ClientId != '')" [(ngModel)]="saveBo.clientId" [searchable]="true"
                                                            class="w-100" [clearable]="true" [items]="ClientList"
                                                            bindLabel="Value" bindValue="Key"
                                                            (ngModelChange)="GetClientPmi();onClientChange();checkValidation();checkEligibility()">
                                                        </ng-select>
                                                    </div>
                                                    <!-- Consultant name -->
                                                    <!-- <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75">Consultant Name</label>
                                                        <ng-select [(ngModel)]="saveBo.userId" [searchable]="true"
                                                            class="w-100" [clearable]="true" [items]="UserDropDownList"
                                                            bindLabel="Value" bindValue="Key">
                                                        </ng-select>
                                                    </div> -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75">Employee Name</label>
                                                        <ng-select [(ngModel)]="saveBo.employeeId" [searchable]="true"
                                                            class="w-100" [clearable]="true" [items]="UserDropDownList"
                                                         [disabled]="!fp"  bindLabel="Value" bindValue="Key">
                                                        </ng-select>
                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <!-- Start Date -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75">Start Date</label>
                                                     

                                                            <input type="datetime-local"  class="form-control w-100"  #editstarttime
                                                            [(ngModel)]="StartDate" [max]="startmin" min="1000-01-01T00:00" id="startDatePicker"
                                                            (ngModelChange)="hourscalculation();"
                                                             />



                                                    </div>
                                                    <!-- End Date -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75">End Date</label>
                                                        <input type="datetime-local" class="form-control w-100"
                                                        [max]="startmin" id="endDatePicker"
                                                            [(ngModel)]="EndDate" min="1000-01-01T00:00"
                                                            (ngModelChange)="hourscalculation();" />
                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <!-- Duration -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75">Duration</label>
                                                        <input type="text" class="form-control" disabled
                                                            [(ngModel)]="duration" />
                                                    </div>
                                                    <!-- PMI -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75"> PMI </label>
                                                        <input type="text" class="form-control"  [(ngModel)]="saveBo.pMI" disabled />
                                                        
                                                    </div>
                                                   
                                                    
                                                </div>
                                                <div class="row mt-1">
                                                    <!--Type of Contact -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75"> Type of Contact</label>
                                                        <ng-select [(ngModel)]="saveBo.typeofContactId"
                                                            [searchable]="true" class="w-100" [clearable]="true"
                                                            [items]="ContactList" bindLabel="lovName" name="typeofcontactform" 
                                                            (ngModelChange)="contactTypeChange()" bindValue="id">
                                                        </ng-select>
                                                    </div>
                                                     
                                                    <div class="col-lg-6 col-md-6 d-inline-flex "
                                                        *ngIf="isContactOtherDes">
                                                        <label class="mr-1 label-bold  w-75"> Description </label>
                                                        <textarea rows="7" class="form-control" cols="190"
                                                            [(ngModel)]="saveBo.contactDescribe"></textarea>
                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <!--Type of session -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75"> Type of session</label>
                                                        <ng-select 
                                                            [searchable]="true" class="ngselect-maxwidth" [clearable]="true" 
                                                            [items]="ServiceList" [(ngModel)]="saveBo.typeofServiceId"
                                                            (ngModelChange)="getServiceBasedLovValues()" 
                                                            bindLabel="serviceCode" bindValue="id">
                                                        </ng-select>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 d-inline-flex "
                                                         *ngIf="showEligibilityMessage && !isClientEligible">
                                                        <span class="text-danger" style="font-size: 27px; font-weight: bold;">
                                                     Participant Not Eligible
                                                      </span>
                                                    </div>
                                                </div>  
                                                <div class="row mt-3" *ngIf="isSSL">
                                                    <span *ngFor=" let ssl of ServiceSetupList;let i=index">
                                                        <input type="checkbox" [(ngModel)]="ssl.isCheck"
                                                            class="checkbox checkbox-primary styled" name="isSSLform"
                                                            (click)="ssl.description=''" />&nbsp;
                                                        <label for=" Inprogress26"
                                                            class="font-weight-bold pt-1">{{ssl.lovName}}</label>&nbsp;&nbsp;
                                                        <br />
                                                        <div
                                                            *ngIf="ssl?.lovName?.toUpperCase()=='OTHER' && ssl.isCheck">
                                                            <textarea rows="7" class="form-control" cols="190"
                                                                [(ngModel)]="ssl.description"></textarea>
                                                        </div>
                                                    </span>
                                                </div>
                                                <div class="row mt-3" *ngIf="isQAL">
                                                    <span *ngFor=" let qal of QualityAssuranceList;let i=index">
                                                        <input type="checkbox" [(ngModel)]="qal.isCheck" name="isQALform"
                                                            class="checkbox checkbox-primary styled"
                                                            (click)="qal.description=''" />&nbsp;
                                                        <label for=" Inprogress26"
                                                            class="font-weight-bold pt-1">{{qal.lovName}}</label>&nbsp;&nbsp;
                                                        <br />

                                                        <div
                                                            *ngIf="qal?.lovName?.toUpperCase()=='OTHER' && qal.isCheck">
                                                            <textarea rows="7" class="form-control" cols="190"
                                                                [(ngModel)]="qal.description"></textarea>
                                                        </div>
                                                    </span>
                                                </div>
                                                <div class="row mt-3" *ngIf="isOngoing">
                                                    <span *ngFor=" let ong of OngoingList;let i=index">
                                                        <input type="checkbox" [(ngModel)]="ong.isCheck" name="isOngoingform"
                                                            class="checkbox checkbox-primary styled"
                                                            (click)="ong.description=''" />&nbsp;
                                                        <label for=" Inprogress26"
                                                            class="font-weight-bold pt-1">{{ong.lovName}}</label>&nbsp;&nbsp;
                                                        <br />

                                                        <div
                                                            *ngIf="ong?.lovName?.toUpperCase()=='OTHER' && ong.isCheck">
                                                            <textarea rows="7" class="form-control"
                                                                [(ngModel)]="ong.description" cols="190"></textarea>
                                                        </div>
                                                    </span>
                                                </div>
                                                  <!-- <div class="row mt-1" >
                                                      <div class="col-lg-8 col-md-6 d-inline-flex" *ngIf="showEligibilityMessage && !isClientEligible">
                                                  
                                                     </div>
                                                   <div class="col-lg-4 col-md-6 d-inline-flex" *ngIf="showEligibilityMessage && !isClientEligible">
                                                    <span class="text-danger" style="font-size: 20px; font-weight: bold;">
                                                     Participant Not Eligible
                                                      </span>
                                                     </div>
                                                     </div> -->
                                                <div class="row mt-1">
                                                    <label class="mr-1 label-bold w-75">Description of session and
                                                        outcome</label>
                                                    <div class="col-lg-12 col-md-12 d-inline-flex ">
                                                        <textarea rows="7" class="form-control" cols="190"
                                                            style="height: 145px;"
                                                            [(ngModel)]="saveBo.descriptionOfSessionAndOutcome"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="checkTime();" [disabled]="saveBo.employeeId==null || saveBo.employeeId==''||saveBo.employeeId==undefined ||
                saveBo.clientId==null ||saveBo.clientId==undefined ||saveBo.clientId==''||
                StartDate==null || StartDate==undefined || StartDate=='' ||
                EndDate==null || EndDate==undefined || EndDate==''  ||
                saveBo.typeofContactId==null || saveBo.typeofContactId==undefined || saveBo.typeofContactId==''||
                saveBo.typeofServiceId==null || saveBo.typeofServiceId==undefined || saveBo.typeofServiceId==''">
                    <span
                        *ngIf="saveBo.id==null|| saveBo.id==undefined|| saveBo.id=='00000000-0000-0000-0000-000000000000'">
                        Save & Close</span>
                    <span
                        *ngIf="saveBo.id!=null && saveBo.id!=undefined && saveBo.id!='00000000-0000-0000-0000-000000000000'">
                        Update & Close</span>
                </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearEngagement()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- PDF FORM -->
<span id="openPDFModal" data-bs-toggle="modal" data-bs-target="#PDFModalOpen"></span>
<div class="modal fade" id="PDFModalOpen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
            <div class="modal-body card-show">
                <div class="col-lg-12">
                    <app-cfss-pdf-view *ngIf="EmitToChildBo.isChild" [getValues]="EmitToChildBo"
                        (EventEmit)="ParentToChild($event)"></app-cfss-pdf-view>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- delete Modal -->
<span id="openSessionDelete" data-bs-toggle="modal" data-bs-target="#modalSessionDelete"></span>
<div class="modal fade" id="modalSessionDelete" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Session Delete </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteSessionEngagement()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<!-- Warning Modal -->
<span id="openSessionWarning" data-bs-toggle="modal" data-bs-target="#modalSessionWarning"></span>
<div class="modal fade" id="modalSessionWarning" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Alert</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                The Client has {{popupmsg}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">OK</button>
            </div>
        </div>
    </div>
</div>
<!-- Kendo -->

 <div class="pdf-hidden-container" [hidden]="!viewpdf" > 
<kendo-pdf-export #PdfList paperSize="A4" forcePageBreak=".page-break" margin="2cm" >
    <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
        <div class="pageNum">
            &nbsp; Page {{ pageNum }} of {{ totalPages }}
        </div>
    </ng-template>
    <body>
        <div class="row">
            <div class="container">
                <header>
                    <div class="logoImage">
                        <img src="assets/img/sessionpng.png" alt>
                    </div>
                </header>
                <div class="pdf-title-info">Information</div>
                <div class="pdf-title">Person who receives services</div>
                <table class="tab">
                    <tr>
                        <th>FIRST NAME</th>
                        <th width="100px">MI</th>
                        <th>LAST NAME</th>
                        <th width="200px">PMI</th>
                    </tr>
                    <tr>
                        <td><input type="text"  [(ngModel)]="clientFirstName"></td>
                        <td><input type="text" [(ngModel)]="clientMiddlename"></td> 
                        <td><input type="text"  [(ngModel)]="clientLastname"></td>
                        <td><input type="text" [(ngModel)]="saveBo.pMI"></td>
                    </tr>
                </table>
                <div class="pdf-title">Consultation services provider
                    agency</div>
                <table class="tab">
                    <tr>
                        <th>AGENCY/ORGANIZATION NAME</th>
                    </tr>
                    <tr>
                        <td><input type="text" [(ngModel)]="global.agencyName"></td>
                    </tr>
                </table>
                <div class="pdf-title-info"> Session information</div>
                <table class="tab">
                    <tr>
                        <th>SESSION DATE</th>
                        <th>NAME OF CONSULTATION SERVICES EMPLOYEE WHO PROVIDED THE
                            SESSION</th>
                        <th>DURATION</th>
                    </tr>
                    <tr>
                        <td><input type="text" [(ngModel)]="SessionDate"></td>
                        <td><input type="text" [(ngModel)]="saveBo.userName"></td> 
                        <td width="250px"><input type="text" [(ngModel)]="duration"></td>
                    </tr>
                </table>
                <div class="pdf-title">Type of contact</div>
                <div class="pdf-form-group">
                    <div class="radio-options" >
                        <span *ngFor=" let ssl of ContactList;let i=index">
                            <label><input type="radio" [value]="ssl.id" name="typeofcontactpdf" [(ngModel)]="saveBo.typeofContactId">&nbsp; {{ssl.lovName}}</label>
                        </span>
                    </div>
                    <table class="tab ">                        
                        <tr>
                            <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                            <!-- <td><input style="height: 100px;" type="text"  [(ngModel)]="saveBo.contactDescribe"></td> -->
                        </tr>
                        <label class="form-control" style="height: auto; background-color: #f1f4ff; border: none; width: 100%; padding: 6px; box-sizing: border-box; white-space: pre-wrap;">{{saveBo.contactDescribe}}</label>
                    </table>
                </div>
                <div class="pdf-title">Type of session</div>
                <div class="pdf-form-group">
                    <div class="radio-options">
                        <span *ngFor="let sl of ServiceList; let i=index">
                            <label>
                                <input type="radio" [value]="sl.id" name="servicetypepdf" [(ngModel)]="saveBo.typeofServiceId">
                                &nbsp; {{sl.serviceCode}}
                            </label>
                        </span>
                    </div>
                    <div class="radio-options-sub1"  *ngIf="ServiceSetupList.length !=0">
                        <p class="services-setup">Service setup and annual CFSS
                            orientation</p>
                        <p style="margin: 10px 0;">If chosen, select all that
                            apply:</p>
                        <div *ngFor=" let ssl of ServiceSetupList;let i=index">                          
                        <span >
                            <label><input type="checkbox"  class="checkboxclass" [(ngModel)]="ssl.isCheck" name="isSSLpdf">&nbsp; {{ssl.lovName}}</label>
                        </span>
                        <div class="other-outcome2" *ngIf="ssl?.lovName=='Other' && ssl.isCheck">
                            <table class="tab ">                        
                                <tr>
                                    <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                    <!-- <td><input style="height: 100px;" type="text"  [(ngModel)]="saveBo.contactDescribe"></td> -->
                                </tr>
                                <label class="form-control" style="height: auto; background-color: #f1f4ff; border: none; width: 100%; padding: 6px; box-sizing: border-box; white-space: pre-wrap;">{{ssl.description}}</label>
                            </table>
                            <!-- <span style="padding-right: 10px; font-size: 13px;">&nbsp;Describe:</span>
                            <label style="border-bottom: 1px solid #000; padding: 0;" ></label> -->
                            <!-- <input type="text" style="border-bottom: 1px solid #000; padding: 0;" [(ngModel)]="ssl.description"> -->
                            <!-- </tr> -->
                        </div>
                    </div>
                    </div>
                    <div class="radio-options-sub1"  *ngIf="OngoingList.length !=0">
                        <p class="services-setup">Ongoing consultation and skill development</p>
                        <p style="margin: 10px 0;">If chosen, select all that
                            apply:</p>
                        <div *ngFor="let Ogl of OngoingList;let i=index">
                        <span >
                            <label><input type="checkbox"  class="checkboxclass"  class="checkboxclass" [(ngModel)]="Ogl.isCheck" name="isQALpdf">&nbsp;
                                {{Ogl.lovName}}</label>
                        </span>
                        <div class="other-outcome2" *ngIf="Ogl?.lovName=='Other' && Ogl.isCheck">
                            <table class="tab ">                        
                                <tr>
                                    <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                    <!-- <td><input style="height: 100px;" type="text"  [(ngModel)]="saveBo.contactDescribe"></td> -->
                                </tr>
                                <label class="form-control" style="height: auto; background-color: #f1f4ff; border: none; width: 100%; padding: 6px; box-sizing: border-box; white-space: pre-wrap;">{{Ogl.description}}</label>
                            </table>
                            <!-- <span style="padding-right: 10px; font-size: 13px;">&nbsp;Describe:</span> -->
                            <!-- <input type="text" style="border-bottom: 1px solid #000; padding: 0;"  [(ngModel)]="Ogl.description"> -->
                            <!-- <label class="form-control" style="height: auto; background-color: #f1f4ff; border: none; width: 100%; padding: 6px; box-sizing: border-box; white-space: pre-wrap;" >{{Ogl.description}}</label> -->
                        </div>
                    </div>
                    </div>
                    <div class="radio-options-sub1"  *ngIf="QualityAssuranceList.length !=0">
                        <p class="services-setup">Quality assurance support</p>
                        <p style="margin: 10px 0;">If chosen, select all that
                            apply:</p>
                        <div *ngFor="let QAL of QualityAssuranceList;let i=index">
                            <div class="d-flex flex-direction-row" >
                                <input type="checkbox" class="checkboxclass" style="min-width: 20px;" [(ngModel)]="QAL.isCheck"  name="isOngoingpdf">&nbsp;
                                <label>{{QAL.lovName}}</label>
                            </div>
                        <div class="other-outcome2 mt-1 mb-1"  *ngIf="QAL?.lovName=='Other' && QAL.isCheck">
                            <table class="tab ">                        
                                <tr>
                                    <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                    <!-- <td><input style="height: 100px;" type="text"  [(ngModel)]="saveBo.contactDescribe"></td> -->
                                </tr>
                                <label class="form-control" style="height: auto; background-color: #f1f4ff; border: none; width: 100%; padding: 6px; box-sizing: border-box; white-space: pre-wrap;">{{QAL.description}}</label>
                            </table>
                            <!-- <span class="Describe-span">&nbsp;Describe:</span> -->
                            <!-- <label class="form-control" style="height: auto; background-color: #f1f4ff; border: none; width: 100%; padding: 6px; box-sizing: border-box; white-space: pre-wrap;" >{{QAL.description}}</label> -->
                            <!-- <input type="text" style="border-bottom: 1px solid #000; padding: 0;"  [(ngModel)]="QAL.description"> -->
                        </div>
                    </div>
                    </div>
                    <div class="pdf-title" style="margin-top: 20px;">Description of session and outcome</div>
                   
                    <table class="tab" >                     
                        
                        
                            <tr>
                                <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                <!-- <td><input style="height: 100px;" type="text" [(ngModel)]="saveBo.descriptionOfSessionAndOutcome"></td> -->
                                <!-- <td class="form-control" style="height: auto; background-color: #f1f4ff;  width: 100%; padding: 6px;  white-space: pre-wrap;">
                                    {{ saveBo.descriptionOfSessionAndOutcome }}
                                </td> -->
                            </tr>
                            <label class="form-control" style="height: auto; background-color: #f1f4ff;  width: 100%; padding: 6px;  white-space: pre-wrap;" >{{ saveBo.descriptionOfSessionAndOutcome }}</label>
                        
                    </table>
                </div>
            </div>
        </div>
    </body>
</kendo-pdf-export>
 </div> 


<!-- Add this modal for viewing PDF -->
 <!-- Modal for Export CSV -->
<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Export as CSV</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <button class="btn btn-primary btn-sm mb-1" (click)="exportCaseWithPaginationCsv()">
              Print Current page
            </button>
          </div>
          <div class="col-lg-6">
            <button class="btn btn-primary btn-sm mb-1" (click)="exportCaseCsv()">
              Print All pages
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Add this modal for viewing PDF -->
<!-- Add this modal for viewing PDF - COMPLETELY READ-ONLY -->
<span id="openViewPdfModal" data-bs-toggle="modal" data-bs-target="#viewPdfModal"></span>
<div class="modal fade" id="viewPdfModal" tabindex="-1" role="dialog" aria-labelledby="viewPdfModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewPdfModalLabel">View Consultation Session</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeViewPdf()"></button>
            </div>
            <div class="modal-body">
                <div class="pdf-content-container" *ngIf="isDataLoaded">
                    <div class="row">
                        <div class="container">
                            <header>
                                <div class="logoImage">
                                    <img src="assets/img/sessionpng.png" alt>
                                </div>
                            </header>
                            
                            <div class="pdf-title-info">Information</div>
                            <div class="pdf-title">Person who receives services</div>
                            <table class="tab">
                                <tr>
                                    <th>FIRST NAME</th>
                                    <th width="100px">MI</th>
                                    <th>LAST NAME</th>
                                    <th width="200px">PMI</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="readonly-field">{{clientFirstName || 'N/A'}}</div>
                                    </td>
                                    <td>
                                        <div class="readonly-field">{{clientMiddlename || 'N/A'}}</div>
                                    </td>
                                    <td>
                                        <div class="readonly-field">{{clientLastname || 'N/A'}}</div>
                                    </td>
                                    <td>
                                        <div class="readonly-field">{{saveBo.pMI || 'N/A'}}</div>
                                    </td>
                                </tr>
                            </table>
                            
                            <div class="pdf-title">Consultation services provider agency</div>
                            <table class="tab">
                                <tr>
                                    <th>AGENCY/ORGANIZATION NAME</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="readonly-field">{{global.agencyName || 'N/A'}}</div>
                                    </td>
                                </tr>
                            </table>
                            
                            <div class="pdf-title-info">Session information</div>
                            <table class="tab">
                                <tr>
                                    <th>SESSION DATE</th>
                                    <th>NAME OF CONSULTATION SERVICES EMPLOYEE WHO PROVIDED THE SESSION</th>
                                    <th>DURATION</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="readonly-field">{{SessionDate || 'N/A'}}</div>
                                    </td>
                                    <td>
                                        <div class="readonly-field">{{saveBo.userName || 'N/A'}}</div>
                                    </td>
                                    <td width="250px">
                                        <div class="readonly-field">{{duration || 'N/A'}}</div>
                                    </td>
                                </tr>
                            </table>
                            
                            <div class="pdf-title">Type of contact</div>
                            <div class="pdf-form-group">
                                <div class="radio-options">
                                    <span *ngFor="let ssl of ContactList; let i=index">
                                        <label class="readonly-radio">
                                            <span class="radio-indicator" [class.checked]="ssl.id === saveBo.typeofContactId">
                                                <span class="radio-dot" *ngIf="ssl.id === saveBo.typeofContactId"></span>
                                            </span>
                                            &nbsp; {{ssl.lovName}}
                                        </label>
                                    </span>
                                </div>
                                
                                <div *ngIf="isContactOtherDes && saveBo.contactDescribe">
                                    <table class="tab">
                                        <tr>
                                            <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="readonly-textarea">{{saveBo.contactDescribe}}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            
                            <div class="pdf-title">Type of session</div>
                            <div class="pdf-form-group">
                                <div class="radio-options">
                                    <span *ngFor="let sl of ServiceList; let i=index">
                                        <label class="readonly-radio">
                                            <span class="radio-indicator" [class.checked]="sl.id === saveBo.typeofServiceId">
                                                <span class="radio-dot" *ngIf="sl.id === saveBo.typeofServiceId"></span>
                                            </span>
                                            &nbsp; {{sl.serviceCode}}
                                        </label>
                                    </span>
                                </div>
                                
                                <!-- Service Setup and Annual CFSS Orientation -->
                                <div class="radio-options-sub1" *ngIf="isSSL && ServiceSetupList.length > 0">
                                    <p class="services-setup">Service setup and annual CFSS orientation</p>
                                    <p style="margin: 10px 0;">If chosen, select all that apply:</p>                                    
                                    <div *ngFor="let ssl of ServiceSetupList; let i=index">
                                        <div class="checkbox-container">
                                            <label class="readonly-checkbox">
                                                <span class="checkbox-indicator" [class.checked]="ssl.isCheck">
                                                    <span class="checkbox-checkmark" *ngIf="ssl.isCheck"></span>
                                                </span>
                                                &nbsp; {{ssl.lovName}}
                                            </label>
                                        </div>
                                        
                                        <div class="other-outcome2" *ngIf="ssl?.lovName?.toLowerCase() === 'other' && ssl.isCheck && ssl.description">
                                            <table class="tab">
                                                <tr>
                                                    <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="readonly-textarea">{{ssl.description}}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Ongoing Consultation and Skill Development -->
                                <div class="radio-options-sub1" *ngIf="isOngoing && OngoingList.length > 0">
                                    <p class="services-setup">Ongoing consultation and skill development</p>
                                    <p style="margin: 10px 0;">If chosen, select all that apply:</p>                                    
                                    <div *ngFor="let Ogl of OngoingList; let i=index">
                                        <div class="checkbox-container">
                                            <label class="readonly-checkbox">                                               
                                                <span class="checkbox-indicator" [class.checked]="Ogl.isCheck">
                                                    <span class="checkbox-checkmark" *ngIf="Ogl.isCheck"></span>
                                                </span>
                                                &nbsp; {{Ogl.lovName}}
                                            </label>
                                        </div>
                                        
                                        <div class="other-outcome2" *ngIf="Ogl?.lovName?.toLowerCase() === 'other' && Ogl.isCheck && Ogl.description">
                                            <table class="tab">
                                                <tr>
                                                    <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="readonly-textarea">{{Ogl.description}}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Quality Assurance Support -->
                                <div class="radio-options-sub1" *ngIf="isQAL && QualityAssuranceList.length > 0">
                                    <p class="services-setup">Quality assurance support</p>
                                    <p style="margin: 10px 0;">If chosen, select all that apply:</p>
                                    <div *ngFor="let QAL of QualityAssuranceList; let i=index">
                                        <div class="checkbox-container">
                                            <label class="readonly-checkbox">
                                                <span class="checkbox-indicator" [class.checked]="QAL.isCheck">
                                                    <span class="checkbox-checkmark" *ngIf="QAL.isCheck"></span>
                                                </span>
                                                &nbsp; {{QAL.lovName}}
                                            </label>
                                        </div>
                                        
                                        <div class="other-outcome2 mt-1 mb-1" *ngIf="QAL?.lovName?.toLowerCase() === 'other' && QAL.isCheck && QAL.description">
                                            <table class="tab">
                                                <tr>
                                                    <th style="display: inline-block; width: 100%;">DESCRIBE OTHER</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="readonly-textarea">{{QAL.description}}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="pdf-title" style="margin-top: 20px;">Description of session and outcome</div>
                                <table class="tab">
                                    <tr>
                                        <th style="display: inline-block; width: 100%;">SESSION DESCRIPTION</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="readonly-textarea">{{saveBo.descriptionOfSessionAndOutcome || 'No description provided'}}</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Loading indicator -->
                <div *ngIf="!isDataLoaded" class="text-center p-4">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading session data...</span>
                    </div>
                    <p class="mt-2">Loading session data...</p>
                </div>
            </div>
            
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeViewPdf()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>